import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { initSentry } from './lib/sentry';
import ErrorBoundary from './components/ErrorBoundary';
import { queryClient } from './lib/queryClient';
import App from './App';
import './index.css';

// Initialize Sentry FIRST
initSentry();

// Google Analytics is initialized lazily by PageTracker/CookieConsent — only after
// the visitor consents AND only on the public marketing site (never the authed app).

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
          {/* containerStyle.top pushes toasts below the 56px sticky topbar so
              they aren't clipped by the app shell. */}
          <Toaster position="top-right" containerStyle={{ top: 70 }} />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
